module.exports = require("./lib/randomstring");


//////////////////
// WEBPACK FOOTER
// ./~/randomstring/index.js
// module id = 1452
// module chunks = 0